<template>
  <section v-show="points.length" class="national-trust">
    <translate tag="h3"> National Trust </translate>
    <template v-for="(point, index) in points" :key="index">
      <p v-if="point.name" :key="index" class="poi">
        {{ point.name }}
        <translate
          v-if="point.distance"
          class="distance"
          :tt="{ distance: distance(point.distance) }"
        >
          {distance, distance, short}
        </translate>
      </p>
    </template>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { NationalTrustAttraction } from '~/apps/campsite-details/types'
import { convertMetersToDistanceObject } from '~/utility/geo/Distance'

@Component
class CampsiteNationalTrust extends Vue {
  @Prop()
  points: NationalTrustAttraction[]

  distance(distance: string) {
    return convertMetersToDistanceObject(distance)
  }
}

export default toNative(CampsiteNationalTrust)
</script>
